import styled from 'styled-components';

export const StyledBubble = styled.div<{ $isRead?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;

  ${({ $isRead }) =>
    $isRead &&
    `
      color: var(--text-soft);

      svg > svg:first-of-type {
        fill: var(--surface-default);
        stroke: var(--icon-soft);
      }

      svg > g svg {
        fill: var(--icon-soft);
      }
    `}
`;
